import React from 'react';
// import SarasDnDCard from '../../../../library/hooks/bdnd/SarasDnDCard';
import SarasDnDCard from '../../../../library/hooks/dndkit/SarasDnDCard';

const DashLaneItem = ({ rowKey, index, children, isSortMode }) => {
    return (
        <SarasDnDCard rowKey={rowKey} index={index} isSortMode={isSortMode}>
            <li className="uiDashLaneItem">
                <div className="uiDashLaneItemInner">
                    {children}
                </div>
            </li>
        </SarasDnDCard>
    );
};

export default DashLaneItem;
